import { QueryClient } from "react-query";

export { default as APIContainer } from "./Container";
export * from "./fetch";
export * from "./entity-ops";
export * from "./compute";
export { default as ApiError } from "./Error";

export const queryClient = new QueryClient();
